import { useCallback, useEffect, useState } from "react";
import { getAdsOverview, exportAdsOverview } from "../../../api/ads";
import type { AdsOverview } from "../../../api/ads";

export const useAdsOverview = () => {
  const [overview, setOverview] = useState<AdsOverview | null>(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchOverview = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getAdsOverview();
      setOverview(data);
    } catch (err: any) {
      setError(err?.message || "Failed to load overview");
    } finally {
      setLoading(false);
    }
  }, []);

  const exportReport = useCallback(async (): Promise<Blob> => {
    try {
      setExporting(true);
      setError(null);
      return await exportAdsOverview();
    } catch (err: any) {
      setError(err?.message || "Failed to export report");
      throw err;
    } finally {
      setExporting(false);
    }
  }, []);

  useEffect(() => {
    fetchOverview();
  }, [fetchOverview]);

  return {
    functions: { fetchOverview, exportReport },
    values: { overview, error },
    loading,
    exporting,
  };
};
